import { render, staticRenderFns } from "./InboxAssignmentSelect.vue?vue&type=template&id=78415f94&scoped=true&"
import script from "./InboxAssignmentSelect.vue?vue&type=script&lang=ts&"
export * from "./InboxAssignmentSelect.vue?vue&type=script&lang=ts&"
import style0 from "./InboxAssignmentSelect.vue?vue&type=style&index=0&id=78415f94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78415f94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VIcon,VRow,VSelect,VTooltip})
